const EventEmitter = require('events');

import {newReq} from "@/core/request";

export class UserSitePref extends EventEmitter {
    constructor(obj) {
        super();
        this.userId = null;
        this.access = {};
        this.userRestrictions = []
        Object.assign(this, obj)
        this.userRestrictions = this.userRestrictions || []
        this.access.statistics = typeof this.access.statistics != 'undefined' ? this.access.statistics : true;
        this.access.screenshots = typeof this.access.screenshots != 'undefined' ? this.access.screenshots : true;
        this.access.setup = typeof this.access.setup != 'undefined' ? this.access.setup : true;
        this.access.classification = typeof this.access.classification != 'undefined' ? this.access.classification : true;
        this.access.billing = typeof this.access.billing != 'undefined' ? this.access.billing : true;
        this.access.users = typeof this.access.users != 'undefined' ? this.access.users : true;
        this.access.approvals = typeof this.access.approvals != 'undefined' ? this.access.approvals : true;
        this.access.leave = typeof this.access.leave != 'undefined' ? this.access.leave : true;
    }

    get statistics() {
        return this.access.statistics
    }
    get screenshots() {
        return this.access.screenshots
    }
    get setup() {
        return this.access.setup
    }
    get classification() {
        return this.access.classification
    }
    get billing() {
        return this.access.billing
    }
    get users() {
        return this.access.users
    }

    get approvals() {
        return this.access.approvals
    }

    get leave() {
        return this.access.leave
    }


    update(...keys) {
        // const updateObj = JSON.parse(JSON.stringify(this))
        // Object.keys(this).forEach(key => {
        //     if (!(keys || []).includes(key))
        //         delete updateObj[key];
        // })
        // return newReq('POST', `devices/update`, {...updateObj, _id: this._id})
    }
}